// Why: these are the OctoQuote template's CSS pixel values at 0.75pt per px, the same numbers the
// backend's QuotePdfLayout and QuotePdfStyles hold. The sheet is printed, so no colour here may
// come from the MUI theme: QuoteSheetPalette.spec.tsx fails if one does.
export const quoteDocumentColors = {
  paper: "#ffffff",
  ink: "#1a1a1a",
  tableHeader: "#1f8ad6",
  tableHeaderText: "#ffffff",
  stripe: "#f3f6f8",
  struckPrice: "#78868f",
  totalsLabel: "#2c3e50",
  totalsRule: "#cdd6dc",
  caveat: "#5c6b76",
  formRule: "#333333",
  formLabel: "#444444",
  link: "#1f8ad6",
  watermark: "#0d80d8",
  screenShadow: "rgba(0, 0, 0, 0.18)",
} as const;

export const quoteDocumentLayout = {
  pageWidth: "210mm",
  pageHeight: "297mm",
  pageMarginBlock: "18mm",
  pageMarginInline: "16mm",
  pageGap: "16pt",
  bodyFontSize: "7.875pt",
  headingFontSize: "9pt",
  subheadingFontSize: "8.25pt",
  tableHeaderFontSize: "7.5pt",
  formLabelFontSize: "7.5pt",
  caveatFontSize: "7.125pt",
  anchorFontSize: "4.5pt",
  titleFontSize: "25.5pt",
  watermarkFontSize: "90pt",
  bandLineHeight: 1.5,
  proseLineHeight: 1.45,
  topBarHeight: "48pt",
  logoHeight: "24pt",
  headerBandMargin: "21pt 0 19.5pt",
  headerBandGap: "9pt",
  tableHeaderPadding: "6pt",
  tableBodyPadding: "6.75pt",
  cellSidePadding: "7.5pt",
  summaryMarginTop: "10.5pt",
  summaryWidth: "240pt",
  summaryPadding: "4.5pt",
  headingMargin: "15pt 0 6pt",
  formRowGap: "22.5pt",
  signatureLabelGap: "15pt",
  signatureColumnGap: "42pt",
} as const;
